/**
 * Interceptor de API para adicionar header X-Tenant-Id automaticamente
 */

let getCurrentTenantId: (() => string | null) | null = null

/**
 * Registrar função para obter tenantId atual
 * Deve ser chamado pelo TenantProvider
 */
export function registerTenantIdGetter(getter: () => string | null) {
  getCurrentTenantId = getter
}

/**
 * Obter header X-Tenant-Id
 */
export function getTenantHeader(): Record<string, string> {
  const tenantId = getCurrentTenantId?.() || localStorage.getItem('clear-care-current-tenant-id') || null
  if (tenantId) {
    return { 'X-Tenant-Id': tenantId }
  }
  return {}
}

/**
 * Wrapper para fetch que adiciona automaticamente o header X-Tenant-Id
 */
export async function fetchWithTenant(
  url: string,
  options: RequestInit = {}
): Promise<Response> {
  const tenantId = getCurrentTenantId?.() || null
  
  const headers = new Headers(options.headers)
  if (tenantId) {
    headers.set('X-Tenant-Id', tenantId)
  }

  return fetch(url, {
    ...options,
    headers,
  })
}

